import { messaging } from './index';

export const requestFirebaseNotificationPermission = () => new Promise((resolve, reject) => {
  window.Notification.requestPermission()
    .then(() => messaging().getToken())
    .then((firebaseToken) => {
      resolve(firebaseToken);
    })
    .catch((err) => {
      reject(err);
    });
});
export const onMessageListener = () => new Promise((resolve) => {
  messaging().onMessage((payload) => {
    resolve(payload);
  });
});

export const getSeparatedCurrentAndAllById = (data, id) => {
  const current = data.filter((row) => row.id === id);
  const all = data.filter((row) => row.id !== id);
  return {
    current,
    all,
  };
};
